
export const endpoints = {
  /**
   * Url dependiendo del entorno usado
   */

  urlBase: 'https://api-cloud.santalucia.es/', // PRO
  // urlBase: 'https://api-cloud-sltest.santalucia.es/', // TEST
  // urlBase: 'https://api-cloud-sldev.santalucia.es/', // DEV

  urlBaseTPV: 'https://web.irisglobal.es/', // PRO
  // urlBaseTPV: 'https://webtst.irisglobal.es:7070/',  // TEST
  // urlBaseTPV: 'https://webtst.irisglobal.es:7070/', // DEV

  productosInformacion: {
    type: 'get',
    // name: 'sos/funciones/v1/productos/informacion?'
    name: 'iris-funciones-polizas-apk/v1/productos/'
  },
  paisesListar: {
    type: 'get',
    // name: 'sos/funciones/v1.0/paises/listar'
    name: 'iris-funciones-polizas-apk/v1/paises'
  },
  /**
   * presupuestos
   */
  presupuestoGuardar: {
    type: 'post',
    // name: 'sos/presupuesto/v1.0/presupuesto/guardar'
    name: 'iris-polizas-apk/v1/presupuestos'
  },
  presupuestoRecuperar: {
    type: 'get',
    // name: 'sos/presupuesto/v1.0/presupuesto/recuperar'
    name: 'iris-polizas-apk/v1/presupuestos/'
  },
  /**
   * documentacion
   */
  documentacionCorreo: {
    type: 'post',
    // name: 'sos/polizas/v1/documentacion/correo'
    name: 'iris-polizas-apk/v1/polizas/documentos'
  },
  descuentoValidar: {
    type: 'get',
    // name: 'sos/funciones/v1/descuento/validar'
    name: 'iris-funciones-polizas-apk/v1/descuentos'
  },
  polizasEmitir: {
    type: 'post',
    // name: 'sos/polizas/v1.0/polizas/emitir'
    name: 'iris-polizas-apk/v1/polizas'
  },
  polizasRecuperar: {
    type: 'get',
    // name: '/sos/polizas/v1.0/polizas/recuperar'
    name: 'iris-polizas-apk/v1/polizas/'
  },
  comprobarClientes: {
    type: 'post',
    // name: 'sos/funciones/v1/Comprobar-cliente'
    name: 'iris-funciones-polizas-apk/v1/clientes/comprobar-cliente'
  },
  Clientes: {
    type: 'post',
    // name: 'sos/funciones/v1/clientes'
    name: 'iris-funciones-polizas-apk/v1/clientes'
  },
  candidatos: {
    type: 'post',
    name: '/candidatos'
  },
  cotizar: {
    type: 'post',
    // name: 'sos/cotizar/v1.0/cotizar'
    name: 'iris-polizas-apk/v1/cotizaciones/polizas'
  },
  auditoria: {
    type: 'post',
    // name: 'sos/funciones/v1/auditoria'
    name: 'iris-funciones-polizas-apk/v1/auditoria'
  },
  derogacionesValidar: {
    type: 'get',
    // name: 'sos/funciones/v1/derogaciones/validar'
    name: 'iris-funciones-polizas-apk/v1/derogaciones'
  },
  deportesListar: {
    type: 'get',
    // name: 'sos/funciones/v1.0/deportes/listar'
    name: 'iris-funciones-polizas-apk/v1/deportes'
  },
  ambitosPaises: {
    type: 'get',
    // name: 'sos/funciones/v1.0/ambitos/paises'
    name: 'iris-funciones-polizas-apk/v1/ambitos'
  },
  sobreprimasListar: {
    type: 'get',
    // name: 'sos/funciones/v1.0/sobreprimas/listar'
    name: 'iris-funciones-polizas-apk/v1/sobreprimas'
  },
  garantiasOpcionales: {
    type: 'get',
    // name: 'sos/funciones/v1.0/garantiasopcionales/listar'
    name: 'iris-funciones-polizas-apk/v1/garantias-opcionales'
  },
  municipiosRecuperar: {
    type: 'get',
    // name: 'sos/funciones/v1.0/municipios/recuperar'
    name: 'iris-funciones-polizas-apk/v1/municipios-codigo-postal/'

  },
  municipiosNoEspañaRecuperar: {
    type: 'get',
    // name: 'sos/funciones/v1/municipios/paises/'
    name: 'iris-funciones-polizas-apk/v1/municipios'
  },
  documentosadicionales: {
    type: 'get',
    // name: 'sos/documentacion/v1.0/documentosadicionales/pdf/recuperar'
    name: 'iris-documentacion-apk/v1/polizas/adicionales-descarga'

  },
  sectorListar: {
    type: 'get',
    // name: 'sos/funciones/v1.0/sector/listar'
    name: 'iris-funciones-polizas-apk/v1/sectores'
  },
  domiciliationSwift: {
    type: 'get',
    // name: 'sos/funciones/v1/swift'
    name: 'iris-funciones-polizas-apk/v1/swift'
  },
  paisRiesgo: {
    type: 'get',
    // name: 'sos/funciones/v1/riesgos'
    // name: 'iris-funciones-polizas-apk/v1/riesgos-paises'
    name: 'iris-funciones-polizas-apk/v1/avisos-riesgos'
  },
  rented: {
    type: 'post',
    // name: 'sos/presupuesto/v1.0/domicilioalquilado/guardar'
    name: 'iris-polizas-apk/v1/domicilios-alquilados'
  },
  log: {
    type: 'post',
    // name: 'sos/funciones/v1/logs'
    name: 'iris-funciones-polizas-apk/v1/logs'
  },
  /**
   * prefix
   */
  prefijoPaises: {
    type: 'get',
    name: 'iris-funciones-polizas-apk/v1/prefijos-telefonicos'
  },
/**
 * se añaden para la parte de mediadores
 */
  broker: {
    type: 'get',
    name: 'controller/PUA_ServicioLogotipoController/logotipo'
  },
  productosMediadores: {
    type: 'get',
    name: 'iris-funciones-polizas-apk/v1/mediadores/productos'
  },
  auth: {
    type: 'post',
    name: '/auth/realms/stl-pua/protocol/openid-connect/token'
  }
};
